module.exports = __webpack_public_path__ + "static/media/ourbrands-logo2.67b29a2e.png";